import { useTranslation } from 'react-i18next'
import { RfxRow } from './useRfxColumns'

export const useRfxStatusLabel = () => {
  const { t } = useTranslation('dashboard', { keyPrefix: 'rfx-section' })

  return ({ status, round }: Pick<RfxRow, 'status' | 'round'>) => {
    const statusLabel = t(`table.statuses.${status}`)

    return round > 1 ? t('table.statusWithRound', { round, status: statusLabel }) : statusLabel
  }
}
